export const setSelectedStrategyReducer = (state, action) => {
  state.selectedStrategy = action.payload;
};

export const setSelectedPortfolioReducer = (state, action) => {
  state.selectedPortfolio = action.payload;
};

export const setActiveStrategiesReducer = (state, action) => {
  state.activeStrategies = action.payload;
};

export const setPortfolioSearchValueReducer = (state, action) => {
  state.portfolioSearchValue = action.payload;
};

export const setShowAddFundsModalReducer = (state, action) => {
  state.showAddFundsModal = action.payload;
};

export const setShowStatusModalReducer = (state, action) => {
  state.showStatusModal = action.payload;
};

export const setSelectedPortfolioIdsReducer = (state, action) => {
  state.selectedPortfolioIds = action.payload;
};
